<script setup>
import { useVirtualList, toRefs } from '@vueuse/core';
import { watchEffect } from 'vue';

const props = defineProps({
    list: {
        type: Array,
        required: true,
    },
    height: {
        type: String,
        required: false,
    },
    options: {
        type: Object,
        default: () => ({}),
    },
});

const emit = defineEmits(['scroll']);

const { list: listRef } = toRefs(props)

const { list, containerProps, wrapperProps, scrollTo } = useVirtualList(listRef, props.options);

const originalOnScroll = containerProps.onScroll;
containerProps.onScroll = (e) => {
    originalOnScroll?.(e);
    emit('scroll', e);
};

defineExpose({ scrollTo, list, wrapperProps });

watchEffect(() => {
    if (typeof containerProps.style === 'object' && !Array.isArray(containerProps.style)) {
        containerProps.style.height = props.height || '300px';
    }
});
</script>

<template>
    <div v-bind="containerProps">
        <div v-bind="wrapperProps">
            <div v-for="item of list" :key="item.index" :style="{ overFlow: 'hidden', height: item.height }">
                <slot v-bind="item">Please set content</slot>
            </div>
        </div>
    </div>
</template>